import { Box } from "@mui/material";
import { PropsWithChildren } from "react";
import { Body1Typography } from "../../../components/typography";
import { Pages } from "../../../utils";
import DashboardHeader from "../../../components/dashboard-header";

export const AddDesignerFileLayout = ({
  children,
  title,
  subTitle,
  showBackButton = true,
  backPath = Pages.MY_DESIGN_FILES,
}: PropsWithChildren<{
  title: string;
  subTitle: string;
  showBackButton?: boolean;
  backPath?: string;
}>) => {
  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
        minHeight: "100vh",
      }}
    >
      <DashboardHeader 
        title={title}
        showBackButton={showBackButton}
      />
      
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3, // 12px - standardized
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.06)", // standardized shadow
          p: 4,
          mx: 0, // Remove horizontal margin to align with header
          mb: 3, // Add bottom margin for spacing
        }}
      >
        <Body1Typography sx={{ mb: 2 }}>{subTitle}</Body1Typography>
        {children}
      </Box>
    </Box>
  );
};
